var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1.75C25 0.783672 24.2003 0 23.2143 0H1.78572C0.797991 0 0 0.783672 0 1.75C0 2.71797 0.797991 3.5 1.78572 3.5H23.2143C24.2003 3.5 25 2.71797 25 1.75ZM25 10.5C25 9.53203 24.2003 8.75 23.2143 8.75H1.78572C0.797991 8.75 0 9.53203 0 10.5C0 11.468 0.797991 12.25 1.78572 12.25H23.2143C24.2003 12.25 25 11.468 25 10.5ZM1.78572 21H23.2143C24.2003 21 25 20.218 25 19.25C25 18.282 24.2003 17.5 23.2143 17.5H1.78572C0.797991 17.5 0 18.282 0 19.25C0 20.218 0.797991 21 1.78572 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.6f8e1e8e19ba3bf01bf333d49e721d74.svg";
export { ForwardRef as ReactComponent };